"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getAvailableStore = () => {
  try {
    const len = window.localStorage.length; // eslint-disable-line no-unused-vars
    return window.localStorage;
  } catch (localStorageException) /* istanbul ignore next */ /* Cant test this as we cant cause localStorage to throw an exception on access */{
    try {
      const len = window.sessionStorage.length; // eslint-disable-line no-unused-vars
      return window.sessionStorage;
    } catch (sessionStorageException) {
      throw new Error('Could not access local storage!');
    }
  }
};
var _default = exports.default = getAvailableStore;